//メインメニューオープン
document.addEventListener("DOMContentLoaded", function () {
    var openButtons = document.querySelectorAll(".header-menu-openbtn, .overlay");
    var overlay = document.querySelector(".overlay");
    var html = document.documentElement;

    openButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            var menuNav = document.querySelector(".innnermenu");

            if (menuNav.classList.contains("open")) {
                // Close all menus
                document.querySelectorAll(".innnermenu").forEach(function(menu) {
                    menu.classList.remove("open");
                });
                html.classList.remove("open");
                overlay.style.display = "none";
                document.querySelectorAll(".header-menu-openbtn").forEach(function(btn) {
                    btn.classList.remove("open");
                });
            } else {
                // Open the clicked menu and button
                document.querySelectorAll(".innnermenu").forEach(function(menu) {
                    menu.classList.add("open");
                });
                html.classList.add("open");
                overlay.style.display = "block";
                button.classList.add("open");
            }
        });
    });

//メニュー内部
    const parentItems = document.querySelectorAll('.innnermenu-category-list li');
    const childItems = document.querySelectorAll('.category-list-submenu li');

    // 初期状態で最初の親要素と子要素にクラスを付与
    parentItems[0].classList.add('submenuopen-btn');
    childItems.forEach(child => {
        if (child.getAttribute('data-index') === '0') {
            child.classList.add('submenuopen');
        }
    });

    parentItems.forEach(item => {
        item.addEventListener('click', function() {
            const index = this.getAttribute('data-index');

            // 全ての親リストからクラスを削除
            parentItems.forEach(parent => {
                parent.classList.remove('submenuopen-btn');
            });

            // クリックされた親リストにクラスを付与
            this.classList.add('submenuopen-btn');

            // 全ての子リストからクラスを削除
            childItems.forEach(child => {
                child.classList.remove('submenuopen');
            });

            // 対応する子リストにクラスを付与
            childItems.forEach(child => {
                if (child.getAttribute('data-index') === index) {
                    child.classList.add('submenuopen');
                }
            });
        });
    });

    
});

